import {CommonRootState} from '../types';
import {FREEMIUM, LEGACY_PREMIUM, PREMIUM, PREMIUM_FREE} from './constants';

export const selectUserBillingPlan = (state: CommonRootState) => {
  const override = state.user.debugPremiumOverride;
  if (override === true) return PREMIUM;
  if (override === false) return FREEMIUM;

  let status = FREEMIUM;
  if (state.billing.billing.free_subscription) {
    status = PREMIUM_FREE;
  } else if (state.billing.billing.legacy_premium) {
    status = LEGACY_PREMIUM;
  } else if (state.billing.billing.premium) {
    status = PREMIUM;
  }
  return status;
};

export const selectBilling = (state: CommonRootState) => state.billing.billing;

export const selectIsPremium = (state: CommonRootState) => {
  const override = state.user.debugPremiumOverride;
  if (override !== null) return override;
  return state.billing.billing.premium || !!state.billing.billing.free_subscription;
};

export const selectIsLegacyPremium = (state: CommonRootState) => {
  const override = state.user.debugPremiumOverride;
  if (override !== null) return override;
  return (
    state.billing.billing.premium ||
    state.billing.billing.legacy_premium ||
    !!state.billing.billing.free_subscription
  );
};

export const selectPurchase = (state: CommonRootState) =>
  state.billing.billing.purchase;
